/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Object$defineProperties = _interopDefault(require('babel-runtime/core-js/object/define-properties'));
var __ol__ = _interopDefault(require('openlayers'));
var Observable = require('rxjs/Observable');
var merge = require('rxjs/observable/merge');
var olCmp = _interopDefault(require('../mixin/ol-cmp'));
var projTransforms = _interopDefault(require('../mixin/proj-transforms'));
var useMapCmp = _interopDefault(require('../mixin/use-map-cmp'));
var observableFromOlChangeEvent = _interopDefault(require('../rx-ext/from-ol-change-event'));
var assert = require('../util/assert');
var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));
var minilo = require('../util/minilo');

var Geolocation = __ol__.Geolocation;
var props = {
  tracking: {
    type: Boolean,
    default: true
  },
  trackingOptions: Object,
  /**
   * @type {string}
   */
  projection: String
  // todo add autoCenter, bindToPosition
};

var computed = {
  accuracy: function accuracy() {
    if (this.rev && this.$geolocation) {
      return this.$geolocation.getAccuracy();
    }
  },
  altitude: function altitude() {
    if (this.rev && this.$geolocation) {
      return this.$geolocation.getAltitude();
    }
  },
  altitudeAccuracy: function altitudeAccuracy() {
    if (this.rev && this.$geolocation) {
      return this.$geolocation.getAltitudeAccuracy();
    }
  },
  heading: function heading() {
    if (this.rev && this.$geolocation) {
      return this.$geolocation.getHeading();
    }
  },
  speed: function speed() {
    if (this.rev && this.$geolocation) {
      return this.$geolocation.getSpeed();
    }
  },
  position: function position() {
    if (this.rev && this.$geolocation) {
      return this.$geolocation.getPosition();
    }
  },
  positionViewProj: function positionViewProj() {
    if (this.position && this.resolvedDataProjection) {
      return this.pointToViewProj(this.position);
    }
  }
};

var methods = {
  /**
   * @return {ol.Geolocation}
   * @private
   */
  createOlObject: function createOlObject() {
    return new Geolocation({
      tracking: this.tracking,
      trackingOptions: this.trackingOptions,
      projection: this.resolvedDataProjection
    });
  },

  /**
   * @return {void}
   * @private
   */
  mount: function mount() {
    this.subscribeAll();
  },

  /**
   * @return {void}
   * @private
   */
  unmount: function unmount() {
    assert.hasGeolocation(this);

    this.unsubscribeAll();
    this.$geolocation.setTracking(false);
  },

  /**
   * @return {void}
   * @protected
   */
  subscribeAll: function subscribeAll() {
    subscribeToGeolocation.call(this);
  }
};

var watch = {
  /**
   * @param {boolean} value
   */
  tracking: function tracking(value) {
    if (this.$geolocation && value !== this.$geolocation.getTracking()) {
      this.$geolocation.setTracking(value);
    }
  },
  tracingOptions: function tracingOptions(value) {
    this.$geolocation && this.$geolocation.setTrackingOptions(value);
  },
  resolvedDataProjection: function resolvedDataProjection(value) {
    if (this.$geolocation) {
      this.$geolocation.setProjection(value);
    }
  }
};

var Geoloc = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('i', { class: [_vm.$options.name], staticStyle: { "display": "none !important" } }, [_vm._t("default", null, { accuracy: _vm.accuracy, altitude: _vm.altitude, altitudeAccuracy: _vm.altitudeAccuracy, heading: _vm.heading, position: _vm.position, speed: _vm.speed })], 2);
  }, staticRenderFns: [],
  name: 'vl-geoloc',
  mixins: [olCmp, useMapCmp, projTransforms],
  props: props,
  computed: computed,
  methods: methods,
  watch: watch,
  stubVNode: {
    empty: function empty() {
      return this.$options.name;
    }
  },
  created: function created() {
    var _this = this;

    _Object$defineProperties(this, {
      /**
       * @type {ol.Geolocation|undefined}
       */
      $geolocation: {
        enumerable: true,
        get: function get() {
          return _this.$olObject;
        }
      },
      $map: {
        enumerable: true,
        get: function get() {
          return _this.$services && _this.$services.map;
        }
      },
      /**
       * Reference to `ol.View` instance.
       * @type {ol.View|undefined}
       */
      $view: {
        enumerable: true,
        get: function get() {
          return _this.$services && _this.$services.view;
        }
      }
    });
  }
};

/**
 * @return {void}
 * @private
 */
function subscribeToGeolocation() {
  var _this2 = this;

  assert.hasGeolocation(this);

  var ft = 100;
  var changes = merge.merge.call(Observable.Observable, observableFromOlChangeEvent(this.$geolocation, ['accuracy', 'altitude', 'altitudeaccuracy', 'heading', 'speed'], true, ft), observableFromOlChangeEvent(this.$geolocation, 'position', true, ft, function () {
    return _this2.position;
  }));

  this.subscribeTo(changes, function (_ref) {
    var prop = _ref.prop,
        value = _ref.value;

    ++_this2.rev;
    _this2.$emit('update:' + prop, value);
  });
}

/**
 * @alias module:geoloc
 */
var index = {
  /**
   * @alias module:geoloc/geoloc
   */
  Geoloc: Geoloc,
  /**
   * @param {Vue} Vue
   * @param {VueLayersOptions} [options]
   */
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    options = minilo.pick(options, 'dataProjection');
    _Object$assign(Geoloc, options);

    Vue.component(Geoloc.name, Geoloc);
  }
};

module.exports = index;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/geoloc/index.js
// module id = 1460
// module chunks = 1